import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import { StatCard, CardLabel, CardValue, CardUnit, CardSub, Divider, SubRow, SubStat, SubStatValue, SubStatLabel, StatusDot } from './StatCard'
import useNetworkInfo from '../../../hooks/useNetworkInfo'
import useEcoModes from '../../../hooks/useEcoModes'
import { ChainStatsResponse } from '../../../types/API'

export interface ActivityData {
  chainInfo?: ChainStatsResponse
  chainId: number
}

export default function Activity({ chainId, chainInfo }: ActivityData) {
  const { data: networkInfo, isLoading } = useNetworkInfo(chainId)
  const params = useParams()
  const { data: ecoModes, isLoading: ecoModeLoading } = useEcoModes(chainId, params.id || '')

  if (isLoading) return <StatCard />

  const ecoActive = ecoModes?.[0]?.active === true

  return (
    <StatCard>
      <CardLabel>Activity</CardLabel>
      <CardValue>
        {chainInfo?.transactions ? chainInfo.transactions.success : '—'}
        <CardUnit>tx</CardUnit>
      </CardValue>
      <CardSub>last hour</CardSub>
      <Divider />
      <SubRow>
        {!ecoModeLoading && ecoModes && (
          <SubStat>
            <SubStatValue>
              <StatusDot ok={ecoActive} />
              {ecoActive ? 'On' : 'Off'}
            </SubStatValue>
            <SubStatLabel>Eco mode</SubStatLabel>
          </SubStat>
        )}
        {networkInfo?.thresholdAmount && (
          <SubStat>
            <SubStatValue>$ {networkInfo.thresholdAmount}</SubStatValue>
            <SubStatLabel>Threshold</SubStatLabel>
          </SubStat>
        )}
      </SubRow>
    </StatCard>
  )
}
